export const Colors = {
    ThemeColor: "#04B7B1",
    ContrastText : "#ffffff",
    ThemeLightColor : "#ccebe7"
}